import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppContext } from '../containers/appContextContainer';
import errorTypes from '../util/gtm/errorTypes';
import restClient from '../util/web-http-client';

export const useFeatureToggle = () => {
    const { setError } = useContext(AppContext);
    const query = useQuery({
        queryKey: ['featureToggles'],
        queryFn: () => restClient.allFeatureToggles(),
        retry: 1,
    });

    useEffect(() => {
        if (query.error) {
            setError({
                errorType: errorTypes.GET_FEATURE_TOGGLES,
                errorException: query.error as RequestExceptionWithResponse,
            });
        }
    }, [query.error, setError]);

    return query;
};

export default useFeatureToggle;
